
/* Layout */
import Layout from '@/views/layout/Layout';

export default [
  {
    path: '/appPlatform',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: 'App平台报表',
      icon: 'component',
    },
    children: [
      {
        path: '/appPlatform/appPlatform',
        component: () => import('@/myviews/reportForm/appPlatform/AppPlatform'),
        alwaysShow: false,
        name: 'App平台报表',
        meta: {
          title: 'App平台报表',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],//添加   修改   查看页面
          have: [],
        },
        children: []
      },

    ]
  },
  {
    path: '/functionAnalysis',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '功能分析',
      icon: 'component',
    },
    children: [
      {
        path: '/functionAnalysis/functionAnalysis',
        component: () => import('@/myviews/reportForm/functionAnalysis/FunctionAnalysis'),
        alwaysShow: false,
        name: '功能分析',
        meta: {
          title: '功能分析',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],//添加   修改   查看页面
          have: [],
        },
        children: []
      },

    ]
  },

  {
    path: '/userAnalysis',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '用户分析',
      icon: 'component',
    },
    children: [
      {
        path: '/userAnalysis/userAnalysis',
        component: () => import('@/myviews/reportForm/userAnalysis/UserAnalysis'),
        alwaysShow: false,
        name: '用户分析',
        meta: {
          title: '用户分析',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],//添加   修改   查看页面
          have: [],
        },
        children: []
      },
    ]
  },

  {
    path: '/userPhoto',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '用户画像',
      icon: 'component',
    },
    children: [
      {
        path: '/userPhoto/userPhoto',
        component: () => import('@/myviews/reportForm/userPhoto/UserPhoto'),
        alwaysShow: false,
        name: '用户画像',
        meta: {
          title: '用户画像',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],//添加   修改   查看页面
          have: [],
        },
        children: []
      },
    ]
  },
]



// WEBPACK FOOTER //
// ./src/router/dataReportForm/index.js